<template>
  <div class="hello container">
    <h1>ELIXIR Estonia eQTL Catalogue Browser</h1>

    <p>The ELIXIR Estonia eQTL Catalogue Browser is a front end for the <a href="https://www.ebi.ac.uk/eqtl/">eQTL Catalogue</a>.
      It provides a simple interface to quickly check if your variant of interest overlaps any fine mapped eQTL credible set.
      Currently only gene expression eQTLs from RNA-seq and microarrays.
      To access data from other transcript-level quantification methods or full eQTL summary statistics,
      please see our <a href="https://www.ebi.ac.uk/eqtl/Data_access/">Data Access</a> page.</p>

    <h2>What are the columns?</h2>
    <ul>
      <li><strong>molecular trait id</strong> — unique id of the molecular trait quantified. These are currently either Ensembl ids for gene expression quantified from RNA-seq data and Illumina probe ids for microarray data.</li>
      <li><strong>gene name</strong> — name of the gene</li>
      <li><strong>credible set</strong> — unique identifier of the fine mapped credible set</li>
      <li><strong>variant</strong> — unique identifier of the genetic variant (chromosome_position_ref_alt) e.g. <code>chr19_226776_C_T</code>. Based on GRCh38 coordinates and reference genome.</li>
      <li><strong>rs id</strong> — rs id of the genetic variant.</li>
      <li><strong>credible set size</strong> — number of variants in the 95% credible set</li>
      <li><strong>pip</strong> — posterior inclusion probability form SuSiE; posterior probability of the variant being the causal variant.</li>
      <li><strong>p value</strong> — nominal p-value of the eQTL association</li>
      <li><strong>beta</strong> — eQTL effect size from the linear model. The alternative allele is the effect allele.</li>
      <li><strong>se</strong> — standard error of the beta</li>
      <li><strong>dataset</strong> — name of the dataset</li>
      <li><strong>dataset_id</strong> — unique id for the dataset. See the full list in <a href="https://github.com/eQTL-Catalogue/eQTL-Catalogue-resources/blob/master/data_tables/dataset_metadata.tsv">here</a></li>
      <li><strong>dataset label</strong> — biological context: &ltcell-type&gt:&ltstimulation&gt. E.g. macrophage:IFNg_18h+Salmonella_5h means the cell-type is macrophage, and they have been stimulated with Interferon gamma for 18 hours and with Salmonella for 5 hours</li>
      <li><strong>plot_variant</strong> — representative variant in credible set</li>
    </ul>

    <h2>About</h2>
    <p>The ELIXIR Estonia eQTL Catalogue Browser was developed by Ivan Kuzmin, Uku Raudvere, Sariyya Abdullayeva and Kaur Alasoo. For questions, please contact the eQTL Catalogue helpdesk at <a href="mailto:eqtlcatalogue@ebi.ac.uk">eqtlcatalogue@ebi.ac.uk</a>.</p>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
}
// TODO: update descriptions

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

a {
  color: #42b983;
}
</style>
